import { render, staticRenderFns } from "./AsyncPopover.vue?vue&type=template&id=06b17c62&"
import script from "./AsyncPopover.vue?vue&type=script&lang=js&"
export * from "./AsyncPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports